export default __webpack_public_path__ + "static/media/icon-avatar-event.6defb012.svg";